export default {
  title: 'Container'
}

const styles = {
  'containerItem' : "display:grid; padding:1rem;"
}

const Template = args => `
  <cradlepoint-container
    columns="${args.columns}"
    gap="${args.gap}"
    gap-column="${args.gapColumn}"
    gap-row="${args.gapRow}"
    max-width="${args.maxWidth}"
  >
    ${args.content}
  </cradlepoint-container>
`;

export const Default = Template.bind({});

Default.args = {
  content:
`<!-- do not copy code between these comments -->
<div class="container-item" style="${styles.containerItem} background-color:var(--cwc-color-primary, #FFAD00);">
  <h2>Container Item</h2>
</div>
<div class="container-item" style="${styles.containerItem} background-color:var(--cwc-color-accent-b, #008EAA);">
  <h2>Container Item</h2>
</div>
<div class="container-item" style="${styles.containerItem} background-color:var(--cwc-color-accent-d, #C1C6C8);">
  <h2>Container Item</h2>
</div>
<!-- do not copy code between these comments -->`,
  maxWidth: '1350px',
  gap: '1rem',
  gapColumn: '',
  gapRow: '',
  columns: 'repeat(2, 1fr)'
}
